<template>
  <div class="plv-ia-qn-detail-question">
    <div class="plv-ia-qn-detail-question-title">
      <span>{{ questionIndex + 1 }}. 【{{ label }}】{{ question.name }}</span>
      <span v-show="question.isRequired" class="plv-ia-qn-txt-red">*</span>
      <span v-show="question.isScorable" class="plv-ia-qn-txt-blue pws-vclass-qn-txt-blue">（<template v-if="averageScore !== ''">{{ averageScore }}/</template>{{ question.score }} {{ t('plvIA.questionnaire.score') }}）</span>
    </div>

    <!-- 问答 -->
    <div v-if="question.type === 'Q'" class="plv-ia-qn-detail-question-answer">
      <input type="text" readonly />
      <span v-if="statistics" class="plv-ia-qn-detail-question-answer__count"><span class="plv-ia-qn-txt-blue pws-vclass-qn-txt-blue">{{ statistics.total }}</span>{{ t('plvIA.questionnaire.person') }}</span>
    </div>

    <!-- 单选/多选 -->
    <div v-else class="plv-ia-qn-detail-question-options">
      <div
        v-for="(item, index) in question.options"
        :key="`option${index}`"
        :class="['plv-ia-qn-detail-question-options__item', {
          'plv-ia-qn-detail-question-options__item--right pws-vclass-qn-detail-question-options__item--right': isRightAnswer(index),
        }]"
      >
        <div
          :class="['plv-ia-qn-detail-question-options__item__content', {
            'plv-ia-qn-detail-question-options__item__progress': statistics
          }]"
        >
          <span v-if="statistics" class="plv-ia-qn-detail-question-options__item__progress__outer">
            <span class="plv-ia-qn-detail-question-options__item__progress__inner" :style="`width: ${getOptionPercentageStr(index)}`"></span>
          </span>
          <span
            :class="['plv-ia-qn-detail-question-options__item__title pws-vclass-qn-detail-question-options__item__title', {
              'plv-ia-qn-detail-question-options__item__title--normal': !statistics,
              'pws-vclass-qn-detail-question-options--published': status === 'published'
            }]"
          >
            {{ getOptionLabel(index) }}. {{ item }}
          </span>
        </div>
        <div v-if="statistics && statistics.total" class="plv-ia-qn-detail-question-options__item__count">
          <span class="pws-vclass-qn-txt-blue">{{ statistics.options[index] || 0 }}</span>{{ t('plvIA.answerCard.person') }}({{ getOptionPercentageStr(index) }})
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Locale from '@/mixins/locale';
import { getAverageScore, isAnswer, getOptionPercentageStr, toUppercaseLetter } from '@/assets/app/questionnaire/helper';

export default {
  mixins: [Locale],
  props: {
    question: {
      type: Object,
      default: null
    },

    questionIndex: {
      type: Number,
      default: -1,
    },

    statistics: {
      type: Object,
      default: null,
    },
    status: {
      type: String,
      default: 'published'
    }
  },

  data() {
    return {
      averageScore: '',
    };
  },

  computed: {
    label() {
      return {
        R: this.t('plvIA.questionnaire.oneChoiceLabel'),
        C: this.t('plvIA.questionnaire.multipleChoiceLabel'),
        Q: this.t('plvIA.questionnaire.qaLabel'),
      }[this.question.type] || '';
    }
  },

  watch: {
    statistics: {
      immediate: true,
      deep: true,
      handler(statistics) {
        if (this.question.isScorable && statistics) {
          this.averageScore = getAverageScore(statistics.totalScore, statistics.total);
        } else {
          this.averageScore = '';
        }
      }
    }
  },

  methods: {
    getOptionLabel(index) {
      return toUppercaseLetter(index);
    },

    getOptionPercentageStr(index) {
      return getOptionPercentageStr(this.statistics, index);
    },

    isRightAnswer(index) {
      return this.question.isScorable && isAnswer(this.question.answer, index);
    }
  }
};
</script>

<style lang="scss">
$blue: #2196F3;

.plv-ia-qn-detail-question {
  margin-bottom: 20px;
  position: relative;

  input[readonly] {
    width: 100%;
    height: 38px;
    border: 1px solid #CFD8DC;
  }
}

.plv-ia-qn-detail-question-title {
  word-break: break-all;
  line-height: 22px;
  margin-bottom: 15px;
  padding-top: 5px;
  font-size: 0;
  >* {
    font-size: 14px;
  }
}

.plv-ia-qn-detail-question-options {
  box-sizing: border-box;
}

.plv-ia-qn-detail-question-answer,
.plv-ia-qn-detail-question-options__item {
  position: relative;
  padding-right: 12em;

  & +.plv-ia-qn-detail-question-options__item {
    margin-top: 20px;
  }

  &--quick {
    width: 96px;
  }
}

.plv-ia-qn-detail-question-options__item__content {
  width: 100%;
  box-sizing: border-box;
  position: relative;
}

.plv-ia-qn-detail-question-options__item__title {
  text-indent: -1.2em;
  width: 100%;
  display: inline-block;
  color: #546E7A;
  padding: 10px 16px;
  padding-right: 50px;
  line-height: 20px;
  border-radius: 20px;
  position: relative;
  box-sizing: border-box;

  &:before {
    content: '';
    width: 1.2em;
    display: inline-block;
  }

  &:after {
    content: '';
    position: absolute;
    right: 16px;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 16px;
    height: 16px;
    border-radius: 20px;
    background: url(./images/icon-answer-right.png) no-repeat;
    background-size: contain;
    opacity: 0;
  }

  &--normal {
    background: #EDF1F7;
  }
}

.plv-ia-qn-detail-question-options__item__progress__outer {
  border: 1px solid #edf1f7;
  background: transparent;
  position: absolute;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border-radius: 20px;
}
.plv-ia-qn-detail-question-options__item__progress__inner {
  background: #EDF1F7;
  display: block;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  border-radius: 20px;
}

.plv-ia-qn-detail-question-options__item--right {
  .plv-ia-qn-detail-question-options__item__title--normal {
    background: #C0E3FF;
    color: $blue;

    &::after {
      opacity: 1;
    }
  }

  .plv-ia-qn-detail-question-options__item__title {
    color: #2196F3;
  }
}

.plv-ia-qn-detail-question-options__item--right, .plv-ia-qn-detail-question-options__item--blue {
  .plv-ia-qn-detail-question-options__item__progress__outer {
    border-color: #C0E3FF;
  }

  .plv-ia-qn-detail-question-options__item__progress__inner {
    background: #C0E3FF;
  }
}

.plv-ia-qn-detail-question-answer__count,
.plv-ia-qn-detail-question-options__item__count {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 11em;
  line-height: 40px;
  height: 40px;
  color: #546E7A;

  span {
    color: $blue;
  }
}

.plv-ia-answer-question-content__bottom__left {
  float: left;

  .plv-ia-btn-new +.plv-ia-btn-new {
    margin-left: 12px;
  }
}

.plv-ia-answer-question-content__bottom__right {
  float: right;

  .plv-ia-btn-new {
    width: 64px;

    & +.plv-ia-btn-new {
      margin-left: 12px;
    }
  }
}

.plv-ia-answer-statistics {
  line-height: 32px;
  height: 32px;

  span {
    font-size: 20px;
    color: #45ACFF;
    font-weight: bold;
    margin: 0 .2em;
  }
}

.plv-ia-answer-question-content__result {
  span {
    font-size: 24px;
    color: #45ACFF;
    font-weight: bold;
    margin: 0 .2em;
  }
}
</style>
